import { apiRequest } from "../../index";

export const createTable = async (data) => {
  return apiRequest("/api/owner/restaurant/tables/plan", "POST", data);
};

export const getTablesByRestaurant = async (restaurantId) => {
  return apiRequest(`/api/owner/restaurant/tables/plan/${restaurantId}`, "GET");
};

export const updateTable = async (data) => {
  return apiRequest(`/api/owner/restaurant/tables/plan/${data?.id}`, "PUT", data);
};

export const deleteTable = async (id) => {
  return apiRequest(`/api/owner/restaurant/tables/plan/${id}`, "DELETE");
};
